import request from '@/utils/request'

/**
 * @description 获取停购模板列表
 * @param {*} data
 */
export function getStopTemplateList() {
  return request.post('/phalapi/public/?service=Shop.Shop.stopBuyList')
}

/**
 * @description 获取退款理由列表
 * @param data
 * @returns {*}
 */
export function getRefundReasonList(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.getRefundReasonList', data)
}

/**
 * @description 保存退款理由
 * @param data
 * @returns {*}
 */
export function saveRefundReason(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.saveRefundReason', data)
}

/**
 * @description 删除退款理由
 * @param data
 * @returns {*}
 */
export function deleteRefundReason(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.DelRefundReason', data)
}

/**
 * @description 获取转考试理由
 * @returns
 */
export function getChangeReasonList() {
  return request.post('/phalapi/public/?service=Shop.Shop.getChangeExamReasonList')
}

/**
 * @description 保存转考试理由
 * @param {*} data
 * @returns
 */
export function saveChangeReason(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.saveChangeExamReason', data)
}

/**
 * @description 删除转考试理由
 * @param {*} data
 * @returns
 */
export function deleteChangeReason(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.delChangeExamReason', data)
}

/**
 * @description 确认转考试
 * @param {*} data
 * @returns
 */
export function confirmChangeExam(data) {
  return request.post('/phalapi/public/?service=App.Shop.TradeChangeExam', data)
}

/**
 * @description 统一退款接口
 * @param {*} data trade_type：goods，rim，integral，seckill，exam，tiku，chongci，ziliao，video，ebook，zhentiji，epaper，fallible，presell
 * @returns
 */
export function tradeRefund(data) {
  return request.post('/phalapi/public/?service=App.Trade.CommonRefundTrade', data)
}

/**
 * @description 检查订单退款状态
 * @param {*} data
 * @returns
 */
export function checkTradeRefund(data) {
  return request.post('/phalapi/public/?service=App.Trade.checkRefund', data)
}

/**
 * @description 检查退货商品超时次数
 * @param {*} data
 * @returns
 */
export function checkRefundGoodsOvertime(data) {
  return request.post('/phalapi/public/?service=App.Trade.getReturnGoodsOvertime', data)
}
/**
 * @description 修改退货理由
 * @param {*} data
 * @returns
 */
export function updateRefundRecord(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.updateRefundRecord', data)
}

/**
 * @description 获取待推送消息列表
 * @param {*} data
 * @returns
 */
export function getPendingPushList(data) {
  return request.post('/phalapi/public/?service=App.Shop.GetShopGoodsPendingPushMsg', data)
}

/**
 * @description 删除待推送消息
 * @param {*} data
 * @returns
 */
export function deletePendingPushMsg(data) {
  return request.post('/phalapi/public/?service=App.Shop.DelShopGoodsPendingPushMsg', data)
}

/**
 * @description 获取商品子类型标签列表
 * @param {*} data
 * @returns
 */
export function getVideoTagList(data) {
  return request.post('/phalapi/public/?service=App.Shop.getShopGoodsVideoTagsList', data)
}

/**
 * @description 获取转考试记录日志列表
 * @param {*} data
 * @returns
 */
export function getExamChangeLogLists(data) {
  return request.post('/phalapi/public/?service=App.Shop.ExamChangeLogLists', data)
}

/**
 * @description 获取订单延期信息
 * @param {*} data
 * @returns
 */
export function getOrderDelayInfo(data) {
  return request.post('/phalapi/public/?service=Shop.Delay.GetTradeDelayLogInfo', data)
}

/**
 * @description 保存订单延期信息
 * @param {*} data
 * @returns
 */
export function saveDelay(data) {
  return request.post('/phalapi/public/?service=Shop.Delay.AddTradeDelayLog', data)
}

/**
 * @description 获取上次活动减价数据
 * @param {*} data
 * @returns
 */
export function getActivityDiscountPrice(data) {
  return request.post('/phalapi/public/?service=App.Activity.getDiscountPrice', data)
}
/**
 * @description 获取考试视频商品
 * @param {*} data
 * @returns
 */
export function getExamVideoGoodsApi(data) {
  return request.post('/phalapi/public/?service=Shop.Shop.GetExamVideoGoods', data)
}
